<template>
        <CModal
            :show="isDisaters"
            title="แบบฟอร์มแจ้งเหตุ"
            add-content-classes="modal-rounded"
            color="secondary"
            :centered="true"
            :close-on-backdrop="true"
            size="lg"
            @update:show="onToggleShow"
        >
          <template #body-wrapper>
            <ReportForm :show-chat-switch="false" :show-internal-header="false" />
          </template>
          <template #footer-wrapper>
            <div class=""></div>
          </template>
        </CModal>
</template>

<script>

import {mapGetters} from 'vuex'
import QEditor from "@/projects/components/Util/QEditor.vue";
import ReportForm from "@/projects/views/reports/components/ReportForm.vue";
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.snow.css'

import Vue from 'vue'
import Multiselect from "vue-multiselect";
import 'vue-multiselect/dist/vue-multiselect.min.css'
Vue.use(VueQuillEditor)

export default {
  name: 'CDisasters',
  components: { Multiselect, QEditor, ReportForm},
    data: function () {
        return {
        }
    },
    mounted() {

    },

    created() {
    },

    beforeDestroy() {

    },

    methods: {
      onToggleShow(val) {
        // อัปเดตค่า isDisaters ใน vuex ให้ตรงกับสถานะ modal
        this.$store.commit("dialog/isDisaters", val);
      }
    },

    computed: {
        ...mapGetters({
          isDisaters: "dialog/isDisaters",
        })
    },

    watch: {

    }
}
</script>

<style scoped>
::v-deep .modal-rounded {
  border-radius: 1rem !important;
  overflow: hidden; 
}

::v-deep .modal-title {
  color: #3d3c3c !important;
  font-weight: 600;
}
</style>
